import PostAPI from '@/apis/business/postAPI'
import CrudBase from '@/stores/crudBase.js'

const crudBase = new CrudBase('post', PostAPI)
export default {
  namespaced: true,
  state: {
    ...crudBase.state,
    posts: [],
    postDetail: {},
    selectedPost: 0,
  },
  mutations: {
    ...crudBase.mutations,

    setPosts (state, params) {
      state.posts = params
    },

    setPostDetail (state, params) {
      state.postDetail = params
    },

    updateSelectedPost (state, index) {
      state.selectedPost = index
    },
  },
  getters: {
    ...crudBase.getters,
  },
  actions: {
    ...crudBase.actions,

    /**
     * @description Lấy danh sách thông báo của một trường
     * @param {*} context
     * @param {*} payload
     * @returns
     */
    async getListEnrollmentPost (context, payload) {
      const res = await PostAPI.getListEnrollmentPost(payload)
      if (res) {
        context.commit('setPosts', res)
      }
      return res
    },

    /**
     * @description Lấy chi tiết thông báo của một trường
     * @param {*} context
     * @param {*} payload
     * @returns
     */
    async getEnrollmentPostById (context, payload) {
      const res = await PostAPI.getEnrollmentPostById(payload)
      if (res) {
        context.commit('setPostDetail', res)
      }
      return res
    },
  },
}
